document.addEventListener('DOMContentLoaded', function () {
  // DOM Elements
  const elements = {
    cartSubTotalLabel: document.getElementById('cartSubTotal'),
    poductionSpeedAttribute: document.getElementById('production-speed-attribute'),
    productionSpeedInputs: document.getElementsByName('production-speed'),
    productionSpeedWrapper: document.getElementById("production-speed-wrapper"),
  };
  
  // Constants
  const cartTotal = Number(elements.productionSpeedWrapper.dataset.cartTotal.replaceAll(",", ""));
  const formatCurrency = (amount) => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(amount);
  const productionSpeedFromLocalStorage = localStorage.getItem('productionSpeed');

  // Helper functions
  const debounce = (func, delay) => {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => func(...args), delay);
    };
  };
  
  const clearProductionSpeedIfCartEmpty = async () => {
    const cartResponse = await fetch('/cart.json');
    const cart = await cartResponse.json();
  
    const hasNormalItems = cart.items.some(item => {
      const title = item.product_title?.toLowerCase() || "";
      return item.handle !== "production-speed-charge" && !title.includes("gift card");
    });
  
    const currentSpeed = localStorage.getItem('productionSpeed');
  
    if (!hasNormalItems && currentSpeed !== "standard") {
      await selectProductionSpeed("standard");
      console.log("--SETTING PRODUCTION SPEED TO STANDARD");
    }
  };
  
  const selectProductionSpeed = async (currentProductionSpeed) => {
   const productionSpeedProductQuantity = currentProductionSpeed === "standard" ? 0 : 1;
   const updates = {
      '50440591966492': productionSpeedProductQuantity,
    };
  
    const sectionsResponse = await fetch('/cart.js');
    const cartData = await sectionsResponse.json();
  
    const existingItem = cartData.items.find(
      item => item.variant_id === 50440591966492
    );
  
    const currentProperties = {
      _productionSpeed: currentProductionSpeed,
    };
  
    const requestBody = {
      attributes: {
        ['Production Speed']: currentProductionSpeed,
      },
      updates,
    };
  
    if (productionSpeedProductQuantity > 0 && !existingItem) {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: 50440591966492,
          quantity: 1,
          properties: currentProperties,
        }),
      });
    } else {
      const lineItem = cartData.items.find(
        item => item.variant_id === 50440591966492
      );
  
      if (lineItem) {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: lineItem.key,
            quantity: productionSpeedProductQuantity,
            properties: currentProperties,
          }),
        });
      }
    }
  
    // Update cart attributes
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: {
          ['Production Speed']: currentProductionSpeed,
        },
      }),
    });

    localStorage.setItem('productionSpeed', currentProductionSpeed);

    document.dispatchEvent(
      new CustomEvent('on:cart:change', { bubbles: true, cancelable: false })
    );
  }

  // Event listener for production speed change
  elements.productionSpeedInputs.forEach(async (input) => {
    const currentProductionSpeed = input.value;
    
    // Select production speed from local storage
    if (productionSpeedFromLocalStorage === currentProductionSpeed) {
      input.checked = true;
      await selectProductionSpeed(productionSpeedFromLocalStorage);
    } else if (!productionSpeedFromLocalStorage && currentProductionSpeed === "standard") {
      input.checked = true;
      await selectProductionSpeed(currentProductionSpeed);
    }
    
    input.addEventListener("change", async () => {
      if (input.checked) {
       await selectProductionSpeed(currentProductionSpeed);
      }
    });
  });

  const calculateProductionShippingtimes = async () => {
    const cartObjectResponse = await fetch('/cart.json');
    const cartObject = await cartObjectResponse.json();  
    const cartTotal = cartObject.items.reduce((total, item) => {
    if (item.handle === "production-speed-charge" || item.handle === "gift-card") {
      return total;
    }
  
    return total + (item.final_line_price / 100);
  }, 0);
    
    const timeLabels = {
      standard: "",
      rush: "",
      express: "",
    };

    const charges = {
      standard: 0,
      rush: cartTotal * 0.25,
      express: cartTotal * 0.5,
    };

    const minimumCharges = {
      standard: 0,
      rush: charges.rush < 75 ? 75 : charges.rush,
      express: charges.express < 150 ? 150 : charges.express,
    };

    const elements = {
      productionStandardTime: document.getElementById('production-speed-standard-time'), 
      productionRushTime: document.getElementById('production-speed-rush-time'),
      productionExpressTime: document.getElementById('production-speed-express-time'),
      productionSpeedWrapper: document.getElementById("production-speed-wrapper"),
      productionStandardLabel: document.getElementById('production-speed-standard-label'),
      productionRushLabel: document.getElementById('production-speed-rush-label'),
      productionExpressLabel: document.getElementById('production-speed-express-label'),
    }   

    const cartItemsCount = cartObject.items.reduce((total, item) => {
      if (item.handle === "production-speed-charge") {
        return total;
      }
    
      const quantity = item.properties?.Quantity ? Number(item.properties.Quantity) : item.quantity;
      return total + quantity;
    }, 0);

    if (cartItemsCount <= 1000) {
      timeLabels.standard = "4 -7 Business Days Following Proof Approval *";
      timeLabels.rush = "48 Hours Following Proof Approval *";
      timeLabels.express = "24 Hours Following Proof Approval *";
    } else if (cartItemsCount <= 5000) {
      timeLabels.standard = "4 -7 Business Days Following Proof Approval *";
      timeLabels.rush = "2 - 3 Business Days Following Proof Approval *";
      timeLabels.express = "24 Hours Following Proof Approval *";
    } else if (cartItemsCount <= 10000) {
      timeLabels.standard = "4 -8 Business Days Following Proof Approval *";
      timeLabels.rush = "3 - 4 Business Days Following Proof Approval *";
      timeLabels.express = "48 Hours Following Proof Approval *";
    } else if (cartItemsCount <= 25000) {
      timeLabels.standard = "5 - 10 Business Days Following Proof Approval *";
      timeLabels.rush = "3 - 5 Business Days Following Proof Approval *";
      timeLabels.express = "2 - 4 Business Days Following Proof Approval *";
    } else if (cartItemsCount <= 50000) {
      timeLabels.standard = "5 - 12 Business Days Following Proof Approval *";
      timeLabels.rush = "4 - 6 Business Days Following Proof Approval *";
      timeLabels.express = "2 - 5 Business Days Following Proof Approval *";
    } else {
      timeLabels.standard = "Call us for a current timeline *";
      timeLabels.rush = "Call us for a current timeline *";
      timeLabels.express = "Call us for a current timeline *";
    }

    elements.productionStandardTime.innerText = timeLabels.standard;
    elements.productionRushTime.innerText = timeLabels.rush;
    elements.productionExpressTime.innerText = timeLabels.express;

    // Update labels
    elements.productionStandardLabel.innerText = `Standard production (+ ${formatCurrency(minimumCharges.standard)})`;
    elements.productionRushLabel.innerText = `Rush production (+ ${formatCurrency(minimumCharges.rush)})`;
    elements.productionExpressLabel.innerText = `Express production (+ ${formatCurrency(minimumCharges.express)})`;
  }

  const toggleProductionSpeedWrapper = async () => {
    const cartResponse = await fetch('/cart.json');
    const cart = await cartResponse.json();
  
    const hasNonGiftCardItem = cart.items.some(item => item.handle !== "gift-card");
  
    const productionSpeedWrapper = document.getElementById("production-speed-wrapper");
  
    if (productionSpeedWrapper) {
      productionSpeedWrapper.style.display = hasNonGiftCardItem ? "block" : "none";
    }
  };

  window.calculateProductionShippingtimes = calculateProductionShippingtimes;
  window.calculateProductionShippingtimes();

  const debouncedClearProductionSpeedIfCartEmpty = debounce(clearProductionSpeedIfCartEmpty, 300);
  window.clearProductionSpeedIfCartEmpty = debouncedClearProductionSpeedIfCartEmpty;
  window.clearProductionSpeedIfCartEmpty();

  window.toggleProductionSpeedWrapper = toggleProductionSpeedWrapper;
  window.toggleProductionSpeedWrapper();
});